var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13796",
    "data-name": "Group 13796",
    transform: "translate(-317 -31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45457",
    "data-name": "Path 45457",
    d: "M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z",
    transform: "translate(317 31)",
    fill: "#000000ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44591",
    "data-name": "Path 44591",
    d: "M68.534,76.233H62.949c-.722,0-.971-.245-.97-.963,0-1.515-.023-3.03.022-4.544a5.016,5.016,0,0,1,4.486-4.688,31.484,31.484,0,0,1,4.127,0,5,5,0,0,1,4.5,4.736c.046,1.545.021,3.092.018,4.639,0,.553-.3.819-.888.82q-2.856,0-5.712,0",
    transform: "translate(263.44 -20.669)",
    fill: "#ffffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44595",
    "data-name": "Path 44595",
    d: "M87.655,7.323A3.661,3.661,0,1,1,91.3,3.641a3.656,3.656,0,0,1-3.648,3.682",
    transform: "translate(244.354 36.531)",
    fill: "#ffffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconDark);
export default __webpack_public_path__ + "static/media/userIcon-dark.4fa27a385be154113ab979ee496f6470.svg";
export { ForwardRef as ReactComponent };